import React from 'react';
import { Link } from 'react-router-dom';

import { ShowLink } from 'component/reuse/show';


export class InstructionsPara extends React.Component {

  render (){
    if (this.props.short){
      return (
        <div className="text-muted small">
          Ingeration 
          <Link className="link-inv" to="/instructions" > Instructions </Link>
          {((this.props.showXID !== undefined)? (
            <span className=""> 
              {"or "}
              <ShowLink show_xid={this.props.showXID} type={"small"} />
            </span>
          ) : (
            ''
          ))}
        </div>
      )
    }
    return (
      <p className={"text-muted small " + this.props.classAdd}>
        Checkout the 
        <Link className="link-inv" to="/instructions"> Instructions </Link> 
        for details
        {((this.props.showXID !== undefined)? (
          <span className=""> 
            {"or "}
            <ShowLink show_xid={this.props.showXID} type={"small"} />
          </span>
        ):(
          ''
        ))}
      </p>
    )
  }
}